import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const CameraActive: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M13.6,5.9 L13.6,13.6 L2.4,13.6 L2.4,5.2 L5.235,5.2 L6.516,3.8 L9.1,3.8 L9.1,2.4 L5.9,2.4 L4.619,3.8 L2.4,3.8 C1.62680135,3.8 1,4.42680135 1,5.2 L1,13.6 C1,14.3731986 1.62680135,15 2.4,15 L13.6,15 C14.3731986,15 15,14.3731986 15,13.6 L15,5.9 L13.6,5.9 Z M10.23,3.20761905 L11.1223077,2.32380952 L12.3453846,3.5352381 L15.1069231,0.8 L15.9992308,1.87428571 L12.3453846,5.49333333 L10.23,3.20761905 Z M4.5,9.4 C4.5,11.3329966 6.06700338,12.9 8,12.9 C9.93299662,12.9 11.5,11.3329966 11.5,9.4 C11.5,8.47174229 11.1312511,7.58150359 10.4748737,6.92512627 C9.81849641,6.26874894 8.92825771,5.9 8,5.9 C6.06700338,5.9 4.5,7.46700338 4.5,9.4 Z M8,11.5 C6.84020203,11.5 5.9,10.559798 5.9,9.4 C5.9,8.24020203 6.84020203,7.3 8,7.3 C9.15979797,7.3 10.1,8.24020203 10.1,9.4 C10.1,10.559798 9.15979797,11.5 8,11.5 Z"
        />
    </SvgIcon>
);

export default CameraActive;
